import React, { useEffect, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faCopy, faEnvelope } from '@fortawesome/free-solid-svg-icons'
import { ActionButton } from 'shared/buttons'

const CopyButton = ({ text, label }) => {
  const [copied, setCopied] = useState(false)

  useEffect(() => {
    if (!copied) return undefined
    const timer = setTimeout(() => setCopied(false), 1500)
    return () => clearTimeout(timer)
  }, [copied])

  const copy = () => navigator.clipboard?.writeText(text).then(() => setCopied(true))

  return (
    <ActionButton
      variant="light"
      className="border text-primary text-nowrap"
      icon={copied ? faCheck : faCopy}
      label={copied ? 'Copied' : `Copy ${label.toLowerCase()}`}
      onClick={copy}
      data-testid={`ask-email-copy-${label.toLowerCase()}`}
    />
  )
}

const Field = ({ label, text, children }) => (
  <div className="d-flex align-items-start gap-2 py-2 border-bottom">
    <span className="small text-muted pt-1" style={{ width: 56 }}>
      {label}
    </span>
    <div className="flex-grow-1 text-break">{children ?? text}</div>
    <CopyButton text={text} label={label} />
  </div>
)

// An email the assistant drafted for the user to send from their own mail; nothing is sent from here.
const EmailCard = ({ email }) => (
  <div className="border rounded-3 px-3 pt-2 pb-3 mb-3 bg-white" style={{ maxWidth: 640 }} data-testid="ask-email">
    <div className="d-flex align-items-center gap-2 fw-semibold text-primary pb-1">
      <FontAwesomeIcon icon={faEnvelope} className="text-info" />
      Email draft
    </div>
    <Field label="To" text={email.to_email}>
      {email.to_name} <span className="text-muted">&lt;{email.to_email}&gt;</span>
    </Field>
    <Field label="Subject" text={email.subject} />
    <Field label="Body" text={email.body}>
      <div style={{ whiteSpace: 'pre-wrap' }}>{email.body}</div>
    </Field>
  </div>
)

export default EmailCard
